import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionSchedulesService } from '../services/constructionSchedules.service';
import { ConstructionScheduleStatsService } from '../services/constructionScheduleStats.service';
import type { ConstructionSchedule, ScheduleFilters } from '../types/construction-schedules.types';
import { useState } from 'react';
import { toast } from 'sonner';

export function useConstructionSchedules(companyId: string, initialFilters: ScheduleFilters = {}) {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState<ScheduleFilters>({
    status: 'all',
    type: 'all',
    ...initialFilters
  });

  const query = useQuery({
    queryKey: ['construction-schedules', companyId, filters],
    queryFn: () => ConstructionSchedulesService.getSchedules(companyId, filters),
    enabled: !!companyId,
  });

  const statsQuery = useQuery({
    queryKey: ['construction-schedule-stats', companyId, filters.projectId],
    queryFn: () => ConstructionScheduleStatsService.getScheduleStats(companyId, filters.projectId),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionSchedule>) => ConstructionSchedulesService.createSchedule(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-schedules'] });
      queryClient.invalidateQueries({ queryKey: ['construction-schedule-stats'] });
      toast.success('Tạo lịch thi công mới thành công');
    },
  });

  return {
    schedules: query.data?.data || [],
    total: query.data?.total || 0,
    stats: statsQuery.data,
    isLoading: query.isLoading || statsQuery.isLoading,
    filters,
    setFilters,
    createSchedule: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
